import React, { useEffect, useRef, useState } from 'react';

import lazyComponent from './lazy-component';

// Like lazyComponent, but the chunk is only loaded and rendered once the
// placeholder comes near the viewport. Keeps heavy below-the-fold widgets
// (e.g. swiper carousels) off the main thread during the initial page load.
// The placeholder must be a single DOM element so it can carry the ref.
export default function lazyWhenVisible(load, placeholder, rootMargin = '200px') {
    const Component = lazyComponent(load, placeholder);

    return function LazyWhenVisible(props) {
        const ref = useRef(null);
        const [visible, setVisible] = useState(
            typeof window === 'undefined' || typeof window.IntersectionObserver !== 'function'
        );

        useEffect(() => {
            if (visible || !ref.current) {
                return undefined;
            }

            const observer = new window.IntersectionObserver((entries) => {
                if (entries.some((entry) => entry.isIntersecting)) {
                    observer.disconnect();
                    setVisible(true);
                }
            }, { rootMargin });

            observer.observe(ref.current);
            return () => observer.disconnect();
        }, [visible]);

        return visible
            ?   <Component {...props} />
            :   React.cloneElement(placeholder, { ref });
    };
}
